'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var cn = require('classnames');
var utils = require('../utils-9a8db0ee.js');
var styled = require('styled-components');
var lightThemeColors = require('../light-theme-colors-bb1a2999.js');
require('../env-100217af.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cn__default = /*#__PURE__*/_interopDefaultLegacy(cn);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

exports.Behavior = void 0;
(function (Behavior) {
    Behavior["Multiline"] = "multiline";
    Behavior["Oneline"] = "oneline";
    Behavior["OnelineEllipsis"] = "oneline-ellipsis";
})(exports.Behavior || (exports.Behavior = {}));
exports.FontScale = void 0;
(function (FontScale) {
    FontScale["XS"] = "xs";
    FontScale["S"] = "s";
    FontScale["M"] = "m";
    FontScale["L"] = "l";
    FontScale["XL"] = "xl";
    FontScale["XXL"] = "xxl";
})(exports.FontScale || (exports.FontScale = {}));
exports.FontWeight = void 0;
(function (FontWeight) {
    FontWeight[FontWeight["NORMAL"] = 400] = "NORMAL";
    FontWeight[FontWeight["HEAVIER"] = 600] = "HEAVIER";
    FontWeight[FontWeight["HEAVIEST"] = 700] = "HEAVIEST";
})(exports.FontWeight || (exports.FontWeight = {}));
exports.FontColor = void 0;
(function (FontColor) {
    FontColor["LIGHT"] = "light";
    FontColor["DARK"] = "dark";
    FontColor["PRIMARY"] = "primary";
    FontColor["POSITIVE"] = "positive";
    FontColor["NEGATIVE"] = "negative";
})(exports.FontColor || (exports.FontColor = {}));
exports.FontEmphasis = void 0;
(function (FontEmphasis) {
    FontEmphasis[FontEmphasis["HIGH"] = 1] = "HIGH";
    FontEmphasis[FontEmphasis["MEDIUM"] = 0.72] = "MEDIUM";
    FontEmphasis[FontEmphasis["LOW"] = 0.48] = "LOW";
})(exports.FontEmphasis || (exports.FontEmphasis = {}));

var scales = {
    xs: {
        fontSize: '0.75rem',
        lineHeight: '20px',
        letterSpacing: '0.02em',
    },
    s: {
        fontSize: '0.875rem',
        lineHeight: '20px',
        letterSpacing: '0.01em',
    },
    m: {
        fontSize: '1rem',
        lineHeight: '24px',
        letterSpacing: '0',
    },
    l: {
        fontSize: '1.25rem',
        lineHeight: '28px',
        letterSpacing: '0',
    },
    xl: {
        fontSize: '1.5rem',
        lineHeight: '32px',
        letterSpacing: '-0.01em',
    },
    xxl: {
        fontSize: '2rem',
        lineHeight: '40px',
        letterSpacing: '-0.02em',
    },
};
var colors = {
    light: lightThemeColors.staticBase0,
    dark: lightThemeColors.staticBase800,
    primary: lightThemeColors.staticMaybeBlue700,
    positive: lightThemeColors.staticPositive700,
    negative: lightThemeColors.staticRedio700,
};
var oneline = styled.css(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"])));
var onelineEllipsis = styled.css(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var Text$1 = styled__default["default"].span.withConfig({ displayName: "Text", componentId: "-i2oez9" })(function (p) { return styled.css(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n    flex: 1 1 auto;\n    user-select: ", ";\n    font-size: ", ";\n    letter-spacing: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    color: ", ";\n    opacity: ", ";\n\n    ", ";\n    ", ";\n  "], ["\n    flex: 1 1 auto;\n    user-select: ", ";\n    font-size: ", ";\n    letter-spacing: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    color: ", ";\n    opacity: ", ";\n\n    ", ";\n    ", ";\n  "])), p.$selectable ? 'auto' : 'none', scales[p.$scale].fontSize, scales[p.$scale].letterSpacing, scales[p.$scale].lineHeight, p.$weight, p.$color ? colors[p.$color] : 'inherit', p.$emphasis, p.$behavior === exports.Behavior.Oneline && oneline, p.$behavior === exports.Behavior.OnelineEllipsis && onelineEllipsis); });
var templateObject_1, templateObject_2, templateObject_3;

/**
 * Component that renders text with different styles.
 */
function Text(_a) {
    var _b = _a.behavior, behavior = _b === void 0 ? exports.Behavior.Multiline : _b, _c = _a.tooltipOnOverflow, tooltipOnOverflow = _c === void 0 ? false : _c, _d = _a.selectable, selectable = _d === void 0 ? true : _d, children = _a.children, _e = _a.container, container = _e === void 0 ? 'span' : _e, containerProps = _a.containerProps, className = _a.className, variant = _a.variant, style = _a.style, _f = _a.scale, scale = _f === void 0 ? exports.FontScale.M : _f, _g = _a.weight, weight = _g === void 0 ? exports.FontWeight.NORMAL : _g, color = _a.color, _h = _a.emphasis, emphasis = _h === void 0 ? exports.FontEmphasis.HIGH : _h;
    var elementRef = React.createRef();
    utils.useIsomorphicLayoutEffect(function () {
        if (!tooltipOnOverflow) {
            return;
        }
        var element = elementRef.current;
        var isOverflowing = element.offsetWidth < element.scrollWidth ||
            element.offsetHeight < element.scrollHeight;
        element.title = isOverflowing && children ? children.toString() : '';
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    tooltipOnOverflow ? undefined : []);
    return (React__default["default"].createElement(Text$1, tslib.__assign({ ref: elementRef, className: cn__default["default"](variant, className), style: style, 
        // `as` type is current broken. Waiting for fix (https://github.com/DefinitelyTyped/DefinitelyTyped/issues/50404)
        as: container }, containerProps, { "$behavior": behavior, "$selectable": selectable, "$scale": scale, "$weight": weight, "$color": color, "$emphasis": emphasis }), children));
}

exports.Text = Text;
//# sourceMappingURL=index.js.map
